// src/components/DropdownButton.tsx
import React, { useState } from 'react'
import styled from '@emotion/styled'
import { motion, AnimatePresence } from 'framer-motion'

export interface DropdownButtonProps {
  trigger: React.ReactNode | (({ open }: { open: boolean }) => React.ReactNode)
  children: React.ReactNode
}

const DropdownButton: React.FC<DropdownButtonProps> = ({ trigger, children }) => {
  const [open, setOpen] = useState(false)
  const buttonId = React.useId()
  const menuId = React.useId()

  const handleToggle = () => {
    setOpen(prev => !prev)
  }

  return (
    <Wrapper>
      <DropdownButtonStyled
        onClick={handleToggle}
        aria-expanded={open}
        aria-haspopup="true"
        aria-controls={menuId}
        id={buttonId}
      >
        {typeof trigger === 'function' ? trigger({ open }) : trigger}
      </DropdownButtonStyled>

      <AnimatePresence initial={false}>
        {open && (
          <DropdownContent
            key="dropdown"
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            transition={{ duration: 0.2 }}
            role="menu"
            id={menuId}
            aria-labelledby={buttonId}
          >
            {children}
          </DropdownContent>
        )}
      </AnimatePresence>
    </Wrapper>
  )
}

const Wrapper = styled.div``

const DropdownButtonStyled = styled.button`
  width: 100%;

  &[aria-expanded='true'] {
    & > div > p {
      font-weight: var(--medium);
    }
  }
`

const DropdownContent = styled(motion.div)``

export default DropdownButton
